<div aria-live="polite" class="search-result-info">
	<span *ngIf="sessionListDataSource.textSearch$ | async as searchTerm; else notSearching">
		<span *ngIf="$any(searchTerm).length > 0">
			<span *ngIf="(sessionListDataSource.loading$ | async) === false; else loading">
				<span *ngIf="(sessionListDataSource.results$ | async)?.length as total"
					class="result-info-found"
					[innerHTML]="'session-list_search-result-found' | translate:
					{ 'searchedText': searchTerm, 'resultsCount': total }">
				</span>
			</span>

			<ng-template #loading>
				<span class="searching">
					<span class="ficon-spinner ficon-spin"></span>
					<span
						translate="session-list_searching"
						[translateParams]="{searchedText: searchTerm}">
					</span>
				</span>
			</ng-template>
		</span>
	</span>

	<ng-template #notSearching>
		<span class="result-info-default"
			*ngIf="(sessionListDataSource.results$ | async)?.length as total"
			translate="session-list_search-result-default"
			[translateParams]="{resultsCount: total}">
		</span>
	</ng-template>
</div>
